import { CoreModal, CoreModalDescription } from "../../core";
import i18nPackage from "../../i18n/i18n";

type NoConfigurationsEnabledModalProps = {
	onClose: () => void;
	onConfirm: () => void;
};

export default function NoConfigurationsEnabledModal({ onClose, onConfirm }: NoConfigurationsEnabledModalProps) {
	return (
		<CoreModal
			title={i18nPackage.t("editQuizPage.noConfigurations.title")}
			open
			widthFixed
			minWidth="min(625px, 80%)"
			maxHeight="min(640px, 80%)"
			onClose={onClose}
			buttons={[
				{
					text: i18nPackage.t("editQuizPage.noConfigurations.cancel"),
					color: "secondary",
					onClick: onClose,
				},
				{
					text: i18nPackage.t("editQuizPage.noConfigurations.yes"),
					onClick: onConfirm,
				},
			]}
		>
			<CoreModalDescription>{i18nPackage.t("editQuizPage.noConfigurations.description")}</CoreModalDescription>
		</CoreModal>
	);
}
